(function () {
  'use strict';

  var LOG_PREFIX = '[buundle Bundle Sync]';
  var DEBUG = false;
  var STYLE_ID = 'buundle-free-label-style';
  var INTERNAL_SOURCE_HEADER = 'X-Buundle-Source';
  var CART_DRAWER_SOURCE_HEADER = 'X-Cart-Drawer-Source';
  var CLEAN_FETCH_IFRAME_ID = '__buundleCleanFetch';

  var CONFIG = {
    mainVariantIds: [
      62119469023603,
      62119469056371,
      62119469089139,
      62543605203315,
      62543605236083,
      62543605268851
    ],
    mainProductHandles: ['dog-calming-diffuser'],
    giftVariantIds: [62807866966387],
    mainGiftVariantIdsByVariant: {
      '62119469023603': [62807866966387],
      '62119469056371': [62807866966387],
      '62119469089139': [62807866966387],
      '62543605203315': [62807866966387],
      '62543605236083': [62807866966387],
      '62543605268851': [62807866966387]
    },
    mainGiftVariantIdsByHandle: {
      'dog-calming-diffuser': [62807866966387]
    },
    giftMultipliersByVariant: {},
    syncDelayMs: 160,
    popupHoldDelayMs: 500,
    labelRefreshBurstsMs: [80, 320, 700],
    cartEvents: [
      'cart:build',
      'cart:refresh',
      'cart:update',
      'cart:updated',
      'cart:item-added',
      'cart:item-updated',
      'cart:synced',
      'shopify:cart:update',
      'shopify:cart:change'
    ],
    visiblePopupSelectors: [
      '.kaching-overlay.kaching-popup-visible',
      'kaching-popup-v2'
    ]
  };

  if (window.__BUUNDLE_SYNC_INITIALIZED__) {
    return;
  }
  window.__BUUNDLE_SYNC_INITIALIZED__ = true;

  var MAIN_VARIANT_SET = toSet(CONFIG.mainVariantIds);
  var MAIN_HANDLE_SET = toSet(CONFIG.mainProductHandles);
  var GIFT_VARIANT_SET = toSet(CONFIG.giftVariantIds);
  var latestFreeState = null;
  var syncTimer = null;
  var syncInFlight = false;
  var syncPending = false;
  var labelTimers = [];
  var cleanFetchPromise = null;

  function toSet(values) {
    var set = {};
    if (!Array.isArray(values)) return set;
    values.forEach(function (value) {
      set[String(value)] = true;
    });
    return set;
  }

  function log() {
  if (!DEBUG) return;
  try {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  } catch (_) {}
 }

  function toNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function isVisibleElement(el) {
    if (!el || el.hidden) return false;
    if (el.getAttribute && el.getAttribute('aria-hidden') === 'true') return false;

    var style = null;
    try {
      style = window.getComputedStyle(el);
    } catch (_) {}

    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) {
      return false;
    }

    if (typeof el.getClientRects === 'function' && el.getClientRects().length > 0) {
      return true;
    }

    return Boolean(el.offsetWidth || el.offsetHeight || el.offsetParent);
  }

  function hasVisiblePopup() {
    for (var i = 0; i < CONFIG.visiblePopupSelectors.length; i += 1) {
      var nodes = document.querySelectorAll(CONFIG.visiblePopupSelectors[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        if (isVisibleElement(nodes[j])) return true;
      }
    }
    return false;
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.buundle-money-free{font-size:0!important;}' +
      '.buundle-money-free::after{' +
      'content:"FREE"!important;' +
      'font-size:14px!important;' +
      'font-weight:700!important;' +
      'display:inline-block!important;' +
      'vertical-align:middle!important;' +
      'margin-bottom:2px!important;' +
      'visibility:visible!important;' +
      '}';

    if (document.head) document.head.appendChild(style);
  }

  function ensureJson(response, endpointName) {
    if (!response || !response.ok) {
      throw new Error(endpointName + ' failed with status ' + (response ? response.status : 'unknown'));
    }
    return response.json();
  }

  function getCleanFetch() {
    if (cleanFetchPromise) return cleanFetchPromise;

    cleanFetchPromise = new Promise(function (resolve) {
      var done = false;
      var fallbackTimer = setTimeout(function () {
        finish(window.fetch.bind(window));
      }, 1500);

      function finish(fetchFn) {
        if (done) return;
        done = true;
        clearTimeout(fallbackTimer);
        resolve(fetchFn);
      }

      function check() {
        if (done) return;

        var mountTarget = document.body || document.documentElement;
        if (!mountTarget) {
          setTimeout(check, 80);
          return;
        }

        var iframe = document.getElementById(CLEAN_FETCH_IFRAME_ID);
        if (!iframe || !iframe.contentWindow) {
          if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
          iframe = document.createElement('iframe');
          iframe.id = CLEAN_FETCH_IFRAME_ID;
          iframe.style.display = 'none';
          mountTarget.appendChild(iframe);
        }

        if (iframe.contentWindow && typeof iframe.contentWindow.fetch === 'function') {
          finish(iframe.contentWindow.fetch.bind(iframe.contentWindow));
          return;
        }

        setTimeout(check, 80);
      }

      check();
    });

    return cleanFetchPromise;
  }

  function cartFetch(path, init) {
    var options = init || {};
    var headers = {};

    if (options.headers && typeof options.headers === 'object') {
      Object.keys(options.headers).forEach(function (key) {
        headers[key] = options.headers[key];
      });
    }

    headers.Accept = headers.Accept || 'application/json';
    headers[INTERNAL_SOURCE_HEADER] = 'internal';
    headers[CART_DRAWER_SOURCE_HEADER] = headers[CART_DRAWER_SOURCE_HEADER] || 'internal';

    return getCleanFetch().then(function (fetchFn) {
      return fetchFn(path, {
        method: options.method || 'GET',
        headers: headers,
        credentials: 'same-origin',
        cache: 'no-store',
        body: options.body
      });
    });
  }

  function isGiftVariant(variantId) {
    return Boolean(GIFT_VARIANT_SET[String(variantId)]);
  }

  function getMainItemVariantId(item) {
    if (!item) return '';
    var id = item.variant_id != null ? item.variant_id : item.id;
    return id != null ? String(id) : '';
  }

  function getMainItemHandle(item) {
    return item && item.handle ? String(item.handle) : '';
  }

  function getGiftVariantIdsForMainItem(item) {
    var variantId = getMainItemVariantId(item);
    var handle = getMainItemHandle(item);

    if (variantId && CONFIG.mainGiftVariantIdsByVariant[variantId]) {
      return CONFIG.mainGiftVariantIdsByVariant[variantId];
    }

    if (handle && CONFIG.mainGiftVariantIdsByHandle[handle]) {
      return CONFIG.mainGiftVariantIdsByHandle[handle];
    }

    if ((variantId && MAIN_VARIANT_SET[variantId]) || (handle && MAIN_HANDLE_SET[handle])) {
      return CONFIG.giftVariantIds;
    }

    return [];
  }

  function isLineFullyFree(item) {
    if (!item || toNumber(item.quantity) <= 0) return false;
    return toNumber(item.final_line_price) === 0 || toNumber(item.final_price) === 0;
  }

  function createGiftQuantityMap() {
    var quantities = {};
    CONFIG.giftVariantIds.forEach(function (giftId) {
      quantities[String(giftId)] = 0;
    });
    return quantities;
  }

  function addGiftQuantitiesForMainItem(quantities, item) {
    if (!quantities || !item) return;

    var mainQty = toNumber(item.quantity);
    if (mainQty <= 0) return;

    var mainVariantId = getMainItemVariantId(item);
    var giftVariantIds = getGiftVariantIdsForMainItem(item);

    giftVariantIds.forEach(function (giftId) {
      var giftKey = String(giftId);
      var multiplier = 1;
      var variantMultipliers = CONFIG.giftMultipliersByVariant[mainVariantId];

      if (variantMultipliers && variantMultipliers[giftKey] !== undefined) {
        multiplier = toNumber(variantMultipliers[giftKey]);
      }

      quantities[giftKey] = toNumber(quantities[giftKey]) + mainQty * multiplier;
    });
  }

  function computeRequiredGiftQuantities(cart) {
    var quantities = createGiftQuantityMap();
    if (!cart || !Array.isArray(cart.items)) return quantities;

    cart.items.forEach(function (item) {
      addGiftQuantitiesForMainItem(quantities, item);
    });

    return quantities;
  }

  function groupGiftLinesByVariant(cart) {
    var groups = createGiftQuantityMap();
    Object.keys(groups).forEach(function (giftKey) {
      groups[giftKey] = [];
    });

    if (!cart || !Array.isArray(cart.items)) return groups;

    cart.items.forEach(function (item) {
      if (isGiftVariant(item.variant_id)) {
        groups[String(item.variant_id)].push(item);
      }
    });

    return groups;
  }

  function pickKeeperLine(lines) {
    if (!Array.isArray(lines) || lines.length === 0) return null;

    for (var i = 0; i < lines.length; i += 1) {
      if (isLineFullyFree(lines[i])) return lines[i];
    }

    return lines[0];
  }

  function buildSyncPlan(cart) {
    var required = computeRequiredGiftQuantities(cart);
    var grouped = groupGiftLinesByVariant(cart);
    var updates = {};
    var additions = [];

    CONFIG.giftVariantIds.forEach(function (giftId) {
      var giftKey = String(giftId);
      var requiredQty = toNumber(required[giftKey]);
      var lines = grouped[giftKey] || [];

      if (lines.length === 0) {
        if (requiredQty > 0) additions.push({ id: giftId, quantity: requiredQty });
        return;
      }

      var keeper = pickKeeperLine(lines);
      lines.forEach(function (line) {
        if (!line || !line.key) return;

        if (keeper && line.key === keeper.key) {
          if (toNumber(line.quantity) !== requiredQty) updates[line.key] = requiredQty;
        } else if (toNumber(line.quantity) !== 0) {
          updates[line.key] = 0;
        }
      });
    });

    return {
      updates: updates,
      additions: additions,
      shouldUpdate: Object.keys(updates).length > 0,
      shouldAdd: additions.length > 0
    };
  }

  function buildFreeState(cart) {
    var freeByKey = {};
    var freeUnitsByVariant = createGiftQuantityMap();

    if (!cart || !Array.isArray(cart.items)) {
      return { freeByKey: freeByKey, freeUnitsByVariant: freeUnitsByVariant };
    }

    cart.items.forEach(function (item) {
      if (!isGiftVariant(item.variant_id)) return;

      var key = item.key ? String(item.key) : '';
      var variantKey = String(item.variant_id);
      var free = isLineFullyFree(item);

      if (key) freeByKey[key] = free;
      if (free) freeUnitsByVariant[variantKey] += toNumber(item.quantity);
    });

    return { freeByKey: freeByKey, freeUnitsByVariant: freeUnitsByVariant };
  }

  function getGiftItemNodes() {
    return Array.prototype.slice.call(document.querySelectorAll([
      '.item[data-variant-id]',
      '[data-variant-id]',
      '[data-cart-item][data-variant-id]',
      '[data-line-item][data-variant-id]'
    ].join(',')));
  }

  function getMoneyNode(itemNode) {
    if (!itemNode || !itemNode.querySelector) return null;
    return itemNode.querySelector('.price:not(.strike-through) .money, .money, [data-cart-item-price], [data-line-price]');
  }

  function getItemKeyFromNode(node) {
    if (!node || !node.getAttribute) return '';

    var keyAttrs = [
      'data-key',
      'data-cart-item-key',
      'data-line-item-key',
      'data-item-key',
      'data-cart-key',
      'data-ajax-cart-item-key'
    ];

    for (var i = 0; i < keyAttrs.length; i += 1) {
      var value = node.getAttribute(keyAttrs[i]);
      if (value) return String(value);
    }

    return '';
  }

  function getItemQuantityFromNode(node) {
    if (!node || !node.querySelector) return 1;

    var input = node.querySelector('input[name="updates[]"], input.quantity__input, input[type="number"]');
    if (input && input.value != null) {
      var parsed = toNumber(input.value);
      return parsed > 0 ? parsed : 1;
    }

    var dataQty = node.getAttribute('data-quantity') || node.getAttribute('data-qty');
    if (dataQty) {
      var attrQty = toNumber(dataQty);
      return attrQty > 0 ? attrQty : 1;
    }

    return 1;
  }

  function applyFreeLabels(freeState) {
    if (!freeState) return;

    var remainingFreeByVariant = {};
    CONFIG.giftVariantIds.forEach(function (giftId) {
      var giftKey = String(giftId);
      remainingFreeByVariant[giftKey] = toNumber(freeState.freeUnitsByVariant[giftKey]);
    });

    getGiftItemNodes().forEach(function (itemNode) {
      var variantId = itemNode.getAttribute('data-variant-id');
      if (!isGiftVariant(variantId)) return;

      var moneyNode = getMoneyNode(itemNode);
      if (!moneyNode) return;

      var itemKey = getItemKeyFromNode(itemNode);
      var itemQty = getItemQuantityFromNode(itemNode);
      var variantKey = String(variantId);
      var isFree = false;

      if (itemKey && Object.prototype.hasOwnProperty.call(freeState.freeByKey, itemKey)) {
        isFree = Boolean(freeState.freeByKey[itemKey]);
      } else if (itemQty > 0 && toNumber(remainingFreeByVariant[variantKey]) >= itemQty) {
        isFree = true;
        remainingFreeByVariant[variantKey] = toNumber(remainingFreeByVariant[variantKey]) - itemQty;
      }

      moneyNode.classList.toggle('buundle-money-free', isFree);
    });
  }

  function clearLabelTimers() {
    labelTimers.forEach(function (timer) {
      clearTimeout(timer);
    });
    labelTimers = [];
  }

  function queueLabelRefreshBurst() {
    clearLabelTimers();
    CONFIG.labelRefreshBurstsMs.forEach(function (delay) {
      labelTimers.push(setTimeout(function () {
        applyFreeLabels(latestFreeState);
      }, toNumber(delay)));
    });
  }

  function isSmartCartDrawerOpen() {
    if (document.body && document.body.classList.contains('cart-drawer-open')) return true;

    var host = document.getElementById('cart-drawer-shadow-host');
    if (!host || !host.shadowRoot) return false;

    try {
      var closeButton = host.shadowRoot.querySelector('button[aria-label="Close cart"], .cart-close-btn');
      if (!closeButton) return false;

      var rect = closeButton.getBoundingClientRect();
      var style = window.getComputedStyle(closeButton);
      return rect.width > 0 &&
        rect.height > 0 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0';
    } catch (_) {
      return false;
    }
  }

  function syncSmartCartDrawer() {
    var drawer = window.themeCartDrawer;
    if (!drawer || typeof drawer.syncWithShopifyCart !== 'function') return;

    var shouldReopen = isSmartCartDrawerOpen();
    Promise.resolve(drawer.syncWithShopifyCart(true))
      .then(function () {
        if (shouldReopen && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function (err) {
        log('Cart drawer sync failed:', err);
      });
  }

  function syncSmartCartDrawerBurst() {
    syncSmartCartDrawer();
    [250, 900, 1600].forEach(function (delay) {
      setTimeout(syncSmartCartDrawer, delay);
    });
  }

  function emitCartEvents(cart) {
    try {
      if (typeof window.SLIDECART_UPDATED === 'function') window.SLIDECART_UPDATED(cart);
      if (typeof window.SLIDECART_SET_CART === 'function') window.SLIDECART_SET_CART(cart);

      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart, source: 'buundle' } }));
      document.dispatchEvent(new CustomEvent('shopify:cart:update', { bubbles: true, detail: { cart: cart, source: 'buundle' } }));
      document.dispatchEvent(new CustomEvent('shopify:cart:change', { bubbles: true, detail: { cart: cart, source: 'buundle' } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, source: 'buundle' } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, source: 'buundle' } }));
      window.dispatchEvent(new CustomEvent('cart:synced', { detail: { cart: cart, source: 'buundle' } }));
      syncSmartCartDrawerBurst();
    } catch (err) {
      log('Failed to emit cart events:', err);
    }
  }

  function refreshLatestFreeState(cart) {
    latestFreeState = buildFreeState(cart);
    applyFreeLabels(latestFreeState);
    queueLabelRefreshBurst();
  }

  async function syncCartState() {
    var cart = await cartFetch('/cart.js?_=' + Date.now()).then(function (res) {
      return ensureJson(res, '/cart.js');
    });

    var plan = buildSyncPlan(cart);
    var changed = false;

    if (plan.shouldUpdate) {
      changed = true;
      await cartFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: plan.updates })
      }).then(function (res) {
        return ensureJson(res, '/cart/update.js');
      });
    }

    if (plan.shouldAdd) {
      changed = true;
      await cartFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: plan.additions })
      }).then(function (res) {
        return ensureJson(res, '/cart/add.js');
      });
    }

    if (changed) {
      cart = await cartFetch('/cart.js?_=' + Date.now()).then(function (res) {
        return ensureJson(res, '/cart.js refresh');
      });
      emitCartEvents(cart);
    }

    refreshLatestFreeState(cart);
  }

  function runSyncIfNeeded() {
    if (hasVisiblePopup()) {
      scheduleSync(CONFIG.popupHoldDelayMs);
      return;
    }

    if (syncInFlight) {
      syncPending = true;
      return;
    }

    syncInFlight = true;
    syncCartState()
      .catch(function (err) {
        log('Sync failed:', err);
      })
      .finally(function () {
        syncInFlight = false;
        if (syncPending) {
          syncPending = false;
          scheduleSync(CONFIG.syncDelayMs);
        }
      });
  }

  function scheduleSync(delayMs) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(runSyncIfNeeded, typeof delayMs === 'number' ? delayMs : CONFIG.syncDelayMs);
  }

  function bindCartEvents() {
    if (window.__BUUNDLE_CART_EVENTS_BOUND__) return;
    window.__BUUNDLE_CART_EVENTS_BOUND__ = true;

    CONFIG.cartEvents.forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (event && event.detail && event.detail.source === 'buundle') {
          queueLabelRefreshBurst();
          return;
        }

        scheduleSync(CONFIG.syncDelayMs);
        queueLabelRefreshBurst();
      });

      window.addEventListener(eventName, function () {
        scheduleSync(CONFIG.syncDelayMs);
        queueLabelRefreshBurst();
      });
    });
  }

  injectStyle();
  bindCartEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(0);
      queueLabelRefreshBurst();
    }, { once: true });
  } else {
    scheduleSync(0);
    queueLabelRefreshBurst();
  }

  window.BuundleSync = {
    refresh: function () {
      scheduleSync(0);
    }
  };

  log('initialized');
})();
